import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { useAccountId } from '../../../auth/useAccountId';
import { useActions } from '../../../Actions';
import * as selectors from '../selectors';
import { useIsAllowed } from '../../../auth/accessToken/Allow';



export const useLocations = () => {
    const canAccessLocations = useIsAllowed([['admin:accounts'], ['admin:locations'], ['read:locations']]);
    const getLocations = useActions('settings.locations').getLocations;
    const getLocationsRef = useRef(getLocations);
    const accountId = useAccountId();
    const locationsById = useSelector(selectors.salesLocations);
    const isLoadingById = useSelector(selectors.isLoading);
    const isLoading = isLoadingById(accountId);
    const locations = locationsById[accountId];
    useEffect(() => {
        if (!locations && !isLoading && canAccessLocations) {
            getLocationsRef.current({ limit: 100 }, accountId);
        }
    }, [accountId, isLoading, locations, getLocationsRef, canAccessLocations]);
    return { locations: locations, isLoading };
};
